module.exports = __webpack_public_path__ + "static/media/mainLogo-white.5e9f1828.png";